import { render, staticRenderFns } from "./MAProfile.vue?vue&type=template&id=3587c4bc&scoped=true&"
import script from "./MAProfile.vue?vue&type=script&lang=js&"
export * from "./MAProfile.vue?vue&type=script&lang=js&"
import style0 from "./MAProfile.vue?vue&type=style&index=0&id=3587c4bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587c4bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
